module.exports = __webpack_public_path__ + "static/website_normal-6bbbc3a23f4375fcd7f1a0c68272fc5d.png";